import { Component } from '@angular/core';

@Component({
  selector: 'needs',
  templateUrl: './needs.component.html'
})

export class NeedsComponent {
  title = 'Needs';
}



// WEBPACK FOOTER //
// ./src/app/needs.component.ts